<script>
  import { afterUpdate } from "svelte";
  import { Navigate, navigateTo } from "svelte-router-spa";
  var words = [];
  var newWord;
  var search = "";

  afterUpdate(() => addPrefetch());

  fetch(`/l`)
    .then(data => data.json())
    .then(data => {
      words = data.words.sort();
    });

  function handleSubmit() {
    if (newWord && words.indexOf(newWord) == -1) {
      fetch("/l", {
        method: "POST",
        body: JSON.stringify({ title: newWord, ορισμός: "--" })
      }).then(data => {
        if (data.status != 200) return;
        navigateTo(`/word/${newWord}`);
      });
    }
  }

  function makeSearch() {
    clearTimeout(window.throttleSearch);
    window.throttleSearch = setTimeout(
      () =>
        fetch(`/l/search/${search}`)
          .then(data => data.json())
          .then(data => (words = data.words)),
      300
    );
  }

  function logOut() {
    document.cookie = `id=`;
    window.location = "/";
  }
</script>

<style>
  .tableAbove {
    display: flex;
  }

  .tableAboveItem {
    flex-grow: 1;
    padding: 1vw;
  }
</style>

<div class="tableAbove">
  {#if !search}
    <div class="tableAboveItem">
      <form on:submit|preventDefault={handleSubmit}>
        <div class="form-group">
          <input
            class="form-control"
            bind:value={newWord}
            placeholder="Ποια λέξη;" />
        </div>
        <button type="submit" class="btn btn-primary btn-sm">Νέα Λέξη</button>
      </form>
    </div>
  {/if}

  <div class="tableAboveItem">
    <input
      class="form-control"
      bind:value={search}
      on:keyup={makeSearch}
      placeholder="Αναζήτηση" />
  </div>
</div>

<ul class="list-group">
  {#each words as word}
    <li class="list-group-item" data-prefetch="/l/{word}" data-prefetchthrottle>
      <Navigate to="/word/{word}">{word}</Navigate>
    </li>
  {/each}
</ul>

<br />
<input
  type="button"
  class="btn btn-danger btn-sm"
  on:click={() => logOut()}
  value="Αποσύνδεση" />
<input
  type="button"
  class="btn btn-dark btn-sm"
  on:click={() => (window.location = '/l/backup.json')}
  value="Αντίγραφο Ασφαλείας" />
